"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../api");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialogFormVisible: false,
      form: {}
    };
  },
  methods: {
    open: function open(id) {
      var _this = this;
      (0, _api.fundsRecordsDetailApi)(id).then(function (res) {
        _this.form = res;
        _this.form.extra = _this.form.extra.split(',');
      });
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.form = {};
      this.dialogFormVisible = false;
    }
  }
};